import { Pipe, PipeTransform } from '@angular/core';
import { TraegerRegBearbeitunsStatus } from '@enums/traegerRegBearbeitungsStatus.enum';

@Pipe({
    name: 'traegerRegBearbeitungsStatusPipe',
    standalone: false
})
export class TraegerRegBearbeitungsStatusPipe implements PipeTransform {
    transform(value: any): string {
        return TraegerRegBearbeitunsStatus.keys()[value].name;
    }
}
